<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'PPPoE Plus Global Config'" style="height: 410px">
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th
                v-for="(value, key) in pppoeplusConfig.title"
                :key="key"
                :title="value"
                :style="{
                  width: key === 'format' || key === 'type' ? '15%' : 'auto',
                }"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in pppoeplusConfig.data"
              :key="index"
              :class="{ 'true:': true }"
            >
              <td style="width: 15%">
                <div>{{ row.format }}</div>
              </td>
              <td style="width: 15%">
                <div>{{ row.type }}</div>
              </td>
              <td>
                <div>{{ row.circuitId }}</div>
              </td>
              <td>
                <div>{{ row.remoteId }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowEditTable">
          <dialog-box
            :btitle="'PPPoE Plus Config'"
            style="min-height: 100%"
            :scroll="true"
            @close="isShowEditTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="format"
                  >Format</label
                >
                <div class="col-sm-7">
                  <select
                    type="text"
                    class="form-control"
                    @focus="flagChange('format')"
                    id="format"
                    v-model="pppoeplusForm.format"
                  >
                    <option label="ascii" value="ascii"></option>
                    <option label="binary" value="binary"></option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="type"
                  >Format Type</label
                >
                <div class="col-sm-7">
                  <select
                    type="text"
                    class="form-control"
                    @focus="flagChange('type')"
                    id="type"
                    v-model="pppoeplusForm.type"
                    @change="
                      ;(pppoeplusForm.circuitId = ''),
                        (pppoeplusForm.remoteId = '')
                    "
                  >
                    <option label="huawei" value="huawei"></option>
                    <option label="standard" value="standard"></option>
                    <option label="self-defined" value="self-defined"></option>
                  </select>
                </div>
              </div>

              <div
                v-if="pppoeplusForm.type == 'self-defined'"
                class="form-group"
              >
                <label class="col-sm-3 control-label" for="circuitId"
                  >Circuit ID</label
                >
                <div class="col-sm-7">
                  <textarea
                    type="text"
                    class="form-control"
                    @focus="flagChange('circuitId')"
                    id="circuitId"
                    :readonly="true"
                    v-model="pppoeplusForm.circuitId"
                    placeholder="STRING<1-128>"
                    autocomplete="off"
                    :title="circuitIdTitle"
                  />
                  <table v-if="configCircuitId == true">
                    <tr>
                      <td style="width: 150px">
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.clientMac"
                          @click="circuitIdChange('client-mac')"
                          id="client-mac"
                          value="client-mac"
                        />
                        <label for="client-mac">client-mac</label>
                      </td>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.cvlan"
                          @click="circuitIdChange('cvlan')"
                          id="cvlan"
                          value="cvlan"
                        /><label for="cvlan">cvlan</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.gemport"
                          @click="circuitIdChange('gemport')"
                          id="gemport"
                          value="gemport"
                        /><label for="gemport">gemport</label>
                      </td>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.hostname"
                          @click="circuitIdChange('hostname')"
                          id="hostname"
                          value="hostname"
                        /><label for="hostname">hostname</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.ontId"
                          @click="circuitIdChange('ont-id')"
                          id="ont-id"
                          value="ont-id"
                        /><label for="ont-id">ont-id</label>
                      </td>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.ontIds"
                          @click="circuitIdChange('ont-id-s')"
                          id="ont-id-s"
                          value="ont-id-s"
                        /><label for="ont-id-s">ont-id-s</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.ontSn"
                          @click="circuitIdChange('ont-sn')"
                          id="ont-sn"
                          value="ont-sn"
                        /><label for="ont-sn">ont-sn</label>
                      </td>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.port"
                          @click="circuitIdChange('port')"
                          id="port"
                          value="port"
                        /><label for="port">port</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.switchMac"
                          @click="circuitIdChange('switch-mac')"
                          id="switch-mac"
                          value="switch-mac"
                        /><label for="switch-mac">switch-mac</label>
                      </td>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.vlan"
                          @click="circuitIdChange('vlan')"
                          id="vlan"
                          value="vlan"
                        /><label for="vlan">vlan</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.oltInterfaceVlan"
                          @click="circuitIdChange('olt-ip-int-vlan')"
                          id="olt-ip-int-vlan"
                          value="olt-ip-int-vlan"
                        /><label for="olt-ip-int-vlan">olt-ip-int-vlan</label>
                      </td>
                      <td
                        :class="{
                          'has-error': checkParameters(
                            'vlan',
                            circuitId.vlanNum
                          ),
                        }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          style="height: 20px"
                          placeholder="INTEGER<1-4094>"
                          autocomplete="off"
                          v-model="circuitId.vlanNum"
                          @change="circuitIdVlanNumber()"
                          :disabled="circuitId.oltInterfaceVlan == false"
                          title="vlan id"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: checkParameters('vlan', circuitId.vlanNum)
                              ? 'block'
                              : 'none',
                          }"
                          >{{ checkParameters("vlan", circuitId.vlanNum) }}
                        </small>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          class="form_checkbox"
                          type="checkbox"
                          v-model="circuitId.userDefined"
                          @click="circuitIdChange('userDefined')"
                          id="userDefined"
                          value="userDefined"
                        /><label for="userDefined">user defined</label>
                      </td>
                      <td
                        :class="{
                          'has-error': checkParameters(
                            'string',
                            circuitId.string
                          ),
                        }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          style="height: 20px"
                          placeholder="STRING<1-128>"
                          v-model="circuitId.string"
                          @change="circuitIdString()"
                          :disabled="circuitId.userDefined == false"
                          autocomplete="off"
                          :title="circuitIdTitle"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: checkParameters('string', circuitId.string)
                              ? 'block'
                              : 'none',
                          }"
                          >{{ checkParameters("string", circuitId.string) }}
                        </small>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div
                v-if="pppoeplusForm.type == 'self-defined'"
                class="form-group"
              >
                <label class="col-sm-3 control-label" for="remoteId"
                  >Remote ID</label
                >
                <div class="col-sm-7">
                  <textarea
                    type="text"
                    class="form-control"
                    @focus="flagChange('remoteId')"
                    id="remoteId"
                    :readonly="true"
                    v-model="pppoeplusForm.remoteId"
                    placeholder="STRING<1-128>"
                    autocomplete="off"
                    :title="remoteIdTitle"
                  />
                  <table v-if="configRemoteId == true">
                    <tr>
                      <td>
                        <div style="width: 150px">
                          <input
                            type="checkbox"
                            v-model="remoteId.clientMac"
                            id="client-mac"
                            @click="remoteIdChange('client-mac')"
                            value="client-mac"
                          />
                          <label for="client-mac">client-mac</label>
                        </div>
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="remoteId.hostname"
                          id="hostname"
                          @click="remoteIdChange('hostname')"
                          value="hostname"
                        /><label for="hostname">hostname</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="checkbox"
                          v-model="remoteId.switchMac"
                          id="switch-mac"
                          @click="remoteIdChange('switch-mac')"
                          value="switch-mac"
                        /><label for="switch-mac">switch-mac</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="checkbox"
                          v-model="remoteId.userDefined"
                          id="userDefined"
                          @click="remoteIdChange('userDefined')"
                          value="userDefined"
                        /><label for="userDefined">user defined</label>
                      </td>
                      <td
                        :class="{
                          'has-error': checkParameters(
                            'string',
                            remoteId.string
                          ),
                        }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          style="height: 20px"
                          v-model="remoteId.string"
                          @change="remoteIdString()"
                          :disabled="remoteId.userDefined == false"
                          placeholder="STRING<1-128>"
                          autocomplete="off"
                          :title="remoteIdTitle"
                        />
                        <small
                          class="help-block"
                          :style="{
                            display: checkParameters('string', remoteId.string)
                              ? 'block'
                              : 'none',
                          }"
                          >{{ checkParameters("string", remoteId.string) }}
                        </small>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "pppoeplusPort",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      pppoeplusConfig: "",
      isShowEditTable: false,
      configCircuitId: false,
      configRemoteId: false,
      circuitId: {
        clientMac: false,
        cvlan: false,
        gemport: false,
        hostname: false,
        oltInterfaceVlan: false,
        vlanNum: "",
        ontId: false,
        ontIds: false,
        ontSn: false,
        port: false,
        switchMac: false,
        vlan: false,
        userDefined: false,
        string: "",
      },
      remoteId: {
        clientMac: false,
        hostname: false,
        switchMac: false,
        userDefined: false,
        string: "",
      },
      pppoeplusForm: {
        format: "",
        type: "",
        circuitId: "",
        oltVlan: "",
        remoteId: "",
      },
      iBox: {},
      circuitIdTitle:
        "format string, use keywords and delimiters to define. Keywords include:\
\r\nclientmac,hostname, switchmac, frame, slot, port, vlan, cvlan, ontid, ontsn,\
\r\ngemport. A valid example: %clientmac.%hostname:%switchmac\
\r\nclient-mac                                contain mac of client\
\r\ncvlan                                       contain vlan of client\
\r\ngemport                                  contain gemport of ont\
\r\nhostname                                contain hostname of switch\
\r\nolt-ip-int-vlan                           primary ip addess of interface vlan\
\r\nont-id                                      contain id of ont (frame/slot/port/id)\
\r\nont-id-s                                   contain id of ont (slot/port/id)\
\r\nont-sn                                     contain serial number of ont\
\r\nport                                        contain port of client\
\r\nswitch-mac                              contain mac of switch\
\r\nvlan                                         contain vlan of service",
      remoteIdTitle:
        "format string, use keywords and delimiters to define. Keywords include:\
\r\nclientmac,hostname, switchmac, frame, slot, port, vlan, cvlan, ontid, ontsn,\
\r\ngemport. A valid example: %clientmac.%hostname:%switchmac\
\r\nclient-mac                                contain mac of client\
\r\nhostname                                contain hostname of switch\
\r\nswitch-mac                              contain mac of switch",
    }
  },

  created() {
    this.loadPppoeplusConfig()
  },

  methods: {
    loadPppoeplusConfig() {
      get("pppoeplusConfig")
        .then((res) => (this.pppoeplusConfig = res.data))
        .catch((err) => {
          this.pppoeplusConfig = en.pppoeplusConfig
        })
    },
    clkEdit() {
      /*初始化*/
      this.pppoeplusForm.circuitId = ""
      this.pppoeplusForm.remoteId = ""
      this.configCircuitId = false
      this.configRemoteId = false
      /*circuitId初始化*/
      this.circuitId.clientMac = false
      this.circuitId.cvlan = false
      this.circuitId.gemport = false
      this.circuitId.hostname = false
      this.circuitId.oltInterfaceVlan = false
      this.circuitId.vlanNum = ""
      this.circuitId.ontId = false
      this.circuitId.ontIds = false
      this.circuitId.ontSn = false
      this.circuitId.port = false
      this.circuitId.switchMac = false
      this.circuitId.vlan = false
      this.circuitId.userDefined = false
      this.circuitId.string = ""

      /*remoteId初始化*/
      this.remoteId.clientMac = false
      this.remoteId.hostname = false
      this.remoteId.switchMac = false
      this.remoteId.userDefined = false
      this.remoteId.string = ""

      this.pppoeplusForm.format =
        this.pppoeplusConfig.data[0].format.toLowerCase()
      this.pppoeplusForm.type = this.pppoeplusConfig.data[0].type
      if (this.pppoeplusForm.type == "self-defined") {
        var circuitIdArr = this.pppoeplusConfig.data[0].circuitId.split(" ")
        var remoteIdArr = this.pppoeplusConfig.data[0].remoteId.split(" ")

        /*circuitId*/
        this.pppoeplusForm.circuitId = this.pppoeplusConfig.data[0].circuitId
          .replace('"', "")
          .replace('"', "")
        for (let i = 0; i < circuitIdArr.length; i++) {
          if (circuitIdArr[i] == "client-mac") {
            this.circuitId.clientMac = true
          } else if (circuitIdArr[i] == "cvlan") {
            this.circuitId.cvlan = true
          } else if (circuitIdArr[i] == "gemport") {
            this.circuitId.gemport = true
          } else if (circuitIdArr[i] == "hostname") {
            this.circuitId.hostname = true
          } else if (circuitIdArr[i] == "olt-ip-int-vlan") {
            this.circuitId.oltInterfaceVlan = true
            this.circuitId.vlanNum = circuitIdArr[i + 1]
          } else if (circuitIdArr[i] == "ont-id") {
            this.circuitId.ontId = true
          } else if (circuitIdArr[i] == "ont-id-s") {
            this.circuitId.ontIds = true
          } else if (circuitIdArr[i] == "ont-sn") {
            this.circuitId.ontSn = true
          } else if (circuitIdArr[i] == "port") {
            this.circuitId.port = true
          } else if (circuitIdArr[i] == "switch-mac") {
            this.circuitId.switchMac = true
          } else if (circuitIdArr[i] == "vlan") {
            this.circuitId.vlan = true
          } else if (circuitIdArr[i][0] == '"') {
            this.circuitId.userDefined = true
            this.circuitId.string = circuitIdArr[i].split('"')[1]
          }
        }
        this.pppoeplusForm.circuitId += " "

        /*remoteId*/
        this.pppoeplusForm.remoteId = this.pppoeplusConfig.data[0].remoteId
          .replace('"', "")
          .replace('"', "")
        for (let i = 0; i < remoteIdArr.length; i++) {
          if (remoteIdArr[i] == "client-mac") {
            this.remoteId.clientMac = true
          } else if (remoteIdArr[i] == "hostname") {
            this.remoteId.hostname = true
          } else if (remoteIdArr[i] == "switch-mac") {
            this.remoteId.switchMac = true
          } else if (remoteIdArr[i][0] == '"') {
            this.remoteId.userDefined = true
            this.remoteId.string = remoteIdArr[i].split('"')[1]
          }
        }
      }
      this.pppoeplusForm.remoteId += " "
      this.isShowEditTable = true
    },

    clkCancel() {
      this.isShowEditTable = false
    },

    clkApply() {
      var pppoeplusConfig = {
        format: this.pppoeplusForm.format,
        type: this.pppoeplusForm.type,
        circuitId: [],
        remoteId: [],
      }
      var circuitIdTmp = this.pppoeplusForm.circuitId.split(" ")
      var remoteIdTmp = this.pppoeplusForm.remoteId.split(" ")
      var i

      /*circuitId 检测*/
      if (
        this.circuitId.oltInterfaceVlan == true &&
        (this.circuitId.vlanNum == "" ||
          null != this.checkParameters("vlan", this.circuitId.vlanNum))
      ) {
        this.showAlertBox("warn", "Message", "Invalid olt interface vlan")
        return
      }
      if (
        this.circuitId.userDefined == true &&
        (this.circuitId.string == "" ||
          null != this.checkParameters("string", this.circuitId.string))
      ) {
        this.showAlertBox(
          "warn",
          "Message",
          "Invalid circuit-id user defined string"
        )
        return
      }
      for (i = 0; i < circuitIdTmp.length; i++) {
        if (circuitIdTmp[i] == "") {
          continue
        }
        pppoeplusConfig.circuitId.push({
          id: circuitIdTmp[i],
        })
      }
      /*remoteId 检测*/
      if (
        this.remoteId.userDefined == true &&
        (this.remoteId.string == "" ||
          null != this.checkParameters("string", this.remoteId.string))
      ) {
        this.showAlertBox(
          "warn",
          "Message",
          "Invalid remote-id user defined string"
        )
        return
      }
      for (i = 0; i < remoteIdTmp.length; i++) {
        if (remoteIdTmp[i] == "") {
          continue
        }
        pppoeplusConfig.remoteId.push({
          id: remoteIdTmp[i],
        })
      }

      if (
        this.pppoeplusForm.type == "self-defined" &&
        this.pppoeplusForm.circuitId == "" &&
        this.pppoeplusForm.remoteId == ""
      ) {
        this.showAlertBox("warn", "Message", "Invalid self-defined parameters")
        return
      }
      post("pppoeplusConfig", pppoeplusConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadPppoeplusConfig()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowEditTable = false
    },

    /* 输入参数检测 */
    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "vlan") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 4094) {
          return "vlan must be in range 1-4094"
        }
      } else if (type == "string") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 128
        ) {
          return "invalid format string"
        }
      }

      return null
    },

    /*是否显示circuit和remote配置的标记*/
    flagChange(str) {
      if (str == "circuitId") {
        this.configCircuitId = true
        this.configRemoteId = false
      } else if (str == "remoteId") {
        this.configCircuitId = false
        this.configRemoteId = true
      } else {
        this.configCircuitId = false
        this.configRemoteId = false
      }
    },

    /* circuitId字符处理 */
    circuitIdChange(keywords) {
      var circuitIdArr = [
        "client-mac",
        "cvlan",
        "gemport",
        "hostname",
        "olt-ip-int-vlan",
        "ont-id",
        "ont-id-s",
        "ont-sn",
        "port",
        "switch-mac",
        "vlan",
      ]
      var i, j

      /*该代码中选择状态为点击前的状态*/
      if (keywords == "client-mac") {
        if (this.circuitId.clientMac == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "client-mac ",
            ""
          )
        }
      } else if (keywords == "cvlan") {
        if (this.circuitId.cvlan == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "cvlan ",
            ""
          )
        }
      } else if (keywords == "gemport") {
        if (this.circuitId.gemport == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "gemport ",
            ""
          )
        }
      } else if (keywords == "hostname") {
        if (this.circuitId.hostname == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "hostname ",
            ""
          )
        }
      } else if (keywords == "ont-id") {
        if (this.circuitId.ontId == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "ont-id ",
            ""
          )
        }
      } else if (keywords == "ont-id-s") {
        if (this.circuitId.ontIds == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "ont-id-s ",
            ""
          )
        }
      } else if (keywords == "ont-sn") {
        if (this.circuitId.ontSn == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "ont-sn ",
            ""
          )
        }
      } else if (keywords == "port") {
        if (this.circuitId.port == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "port ",
            ""
          )
        }
      } else if (keywords == "switch-mac") {
        if (this.circuitId.switchMac == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "switch-mac ",
            ""
          )
        }
      } else if (keywords == "vlan") {
        if (this.circuitId.vlan == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          var arrTmp = this.pppoeplusForm.circuitId.split(" ")
          for (i = 0; i < arrTmp.length; i++) {
            if (arrTmp[i] == "") {
              continue
            }
            if (arrTmp[i] == "vlan") {
              arrTmp.splice(i, 1)
              break
            }
          }

          /* circuitId字符串重组 */
          this.pppoeplusForm.circuitId = ""
          for (j = 0; j < arrTmp.length; j++) {
            if (arrTmp[j] == "") {
              continue
            }
            this.pppoeplusForm.circuitId += arrTmp[j] + " "
          }
        }
      } else if (keywords == "olt-ip-int-vlan") {
        if (this.circuitId.oltInterfaceVlan == false) {
          this.pppoeplusForm.circuitId += keywords + " "
        } else {
          /*删除接口vlan相关参数 */
          var arrTmp = this.pppoeplusForm.circuitId.split(" ")
          for (i = 0; i < arrTmp.length; i++) {
            if (arrTmp[i] == "") {
              continue
            }
            if (arrTmp[i] == "olt-ip-int-vlan") {
              if (i + 1 < arrTmp.length) {
                if (null == this.checkParameters("vlan", arrTmp[i + 1])) {
                  arrTmp.splice(i + 1, 1)
                }
              }
              break
            }
          }

          /* circuitId字符串重组 */
          this.pppoeplusForm.circuitId = ""
          for (j = 0; j < arrTmp.length; j++) {
            if (arrTmp[j] == "") {
              continue
            }
            this.pppoeplusForm.circuitId += arrTmp[j] + " "
          }
          this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
            "olt-ip-int-vlan ",
            ""
          )
          this.circuitId.vlanNum = ""
        }
      } else if (keywords == "userDefined") {
        if (this.circuitId.userDefined == true) {
          var arrTmp = this.pppoeplusForm.circuitId.split(" ")

          /* 删除自定义字符 */
          for (i = 0; i < arrTmp.length; i++) {
            if (arrTmp[i] == "") {
              continue
            }
            if (arrTmp[i] == "olt-ip-int-vlan") {
              if (
                i + 1 < arrTmp.length &&
                null == this.checkParameters("vlan", arrTmp[i + 1])
              ) {
                i += 1
              }
              continue
            }
            for (j = 0; j < circuitIdArr.length; j++) {
              if (arrTmp[i] == circuitIdArr[j]) {
                break
              }
            }
            if (j == circuitIdArr.length) {
              this.pppoeplusForm.circuitId =
                this.pppoeplusForm.circuitId.replace(arrTmp[i] + " ", "")
            }
          }
          this.circuitId.string = ""
        }
      }
    },

    /*curcuitId设备接口vlan配置*/
    circuitIdVlanNumber() {
      var arrTmp = this.pppoeplusForm.circuitId.split(" ")
      var i, j

      if (this.checkParameters("vlan", this.circuitId.vlanNum)) {
        return
      }

      for (i = 0; i < arrTmp.length; i++) {
        if (arrTmp[i] == "") {
          continue
        }
        if (arrTmp[i] == "olt-ip-int-vlan") {
          if (i + 1 < arrTmp.length) {
            if (this.checkParameters("vlan", arrTmp[i + 1])) {
              arrTmp.splice(i + 1, 0, this.circuitId.vlanNum)
            } else {
              arrTmp.splice(i + 1, 1, this.circuitId.vlanNum)
            }
          }
          break
        }
      }
      this.pppoeplusForm.circuitId = ""
      for (j = 0; j < arrTmp.length; j++) {
        if (arrTmp[j] == "") {
          continue
        }
        this.pppoeplusForm.circuitId += arrTmp[j] + " "
      }
    },

    /*curcuitId自定义配置*/
    circuitIdString() {
      var circuitIdArr = [
        "client-mac",
        "cvlan",
        "gemport",
        "hostname",
        "olt-ip-int-vlan",
        "ont-id",
        "ont-id-s",
        "ont-sn",
        "port",
        "switch-mac",
        "vlan",
      ]
      var arrTmp = this.pppoeplusForm.circuitId.split(" ")
      var i, j

      if (this.checkParameters("string", this.circuitId.string)) {
        return
      }

      /* 替换自定义字符 */
      for (i = 0; i < arrTmp.length; i++) {
        if (arrTmp[i] == "") {
          continue
        }
        if (arrTmp[i] == "olt-ip-int-vlan") {
          i += 1
          continue
        }
        for (j = 0; j < circuitIdArr.length; j++) {
          if (arrTmp[i] == circuitIdArr[j]) {
            break
          }
        }
        if (j == circuitIdArr.length) {
          if (this.circuitId.string != "") {
            this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
              arrTmp[i],
              this.circuitId.string
            )
          } else {
            this.pppoeplusForm.circuitId = this.pppoeplusForm.circuitId.replace(
              arrTmp[i] + " ",
              ""
            )
          }
          return
        }
      }
      /* remoteID加上自定义字符 */
      this.pppoeplusForm.circuitId += this.circuitId.string + " "
    },

    remoteIdChange(keywords) {
      var remoteIdArr = ["client-mac", "hostname", "switch-mac"]
      var i, j

      /*该代码中选择状态为点击前的状态*/
      if (keywords == "client-mac") {
        if (this.remoteId.clientMac == false) {
          this.pppoeplusForm.remoteId += keywords + " "
        } else {
          this.pppoeplusForm.remoteId = this.pppoeplusForm.remoteId.replace(
            "client-mac ",
            ""
          )
        }
      } else if (keywords == "hostname") {
        if (this.remoteId.hostname == false) {
          this.pppoeplusForm.remoteId += keywords + " "
        } else {
          this.pppoeplusForm.remoteId = this.pppoeplusForm.remoteId.replace(
            "hostname ",
            ""
          )
        }
      } else if (keywords == "switch-mac") {
        if (this.remoteId.switchMac == false) {
          this.pppoeplusForm.remoteId += keywords + " "
        } else {
          this.pppoeplusForm.remoteId = this.pppoeplusForm.remoteId.replace(
            "switch-mac ",
            ""
          )
        }
      } else if (keywords == "userDefined") {
        if (this.remoteId.userDefined == true) {
          var arrTmp = this.pppoeplusForm.remoteId.split(" ")

          /* 删除自定义字符 */
          for (i = 0; i < arrTmp.length; i++) {
            if (arrTmp[i] == "") {
              continue
            }
            for (j = 0; j < remoteIdArr.length; j++) {
              if (arrTmp[i] == remoteIdArr[j]) {
                break
              }
            }
            if (j == remoteIdArr.length) {
              this.pppoeplusForm.remoteId = this.pppoeplusForm.remoteId.replace(
                arrTmp[i] + " ",
                ""
              )
            }
          }
          this.remoteId.string = ""
        }
      }
    },

    /*remoteId自定义配置*/
    remoteIdString() {
      var remoteIdArr = ["client-mac", "hostname", "switch-mac"]
      var arrTmp = this.pppoeplusForm.remoteId.split(" ")
      var i, j

      if (this.checkParameters("string", this.remoteId.string)) {
        return
      }

      /* 替换自定义字符 */
      for (i = 0; i < arrTmp.length; i++) {
        if (arrTmp[i] == "") {
          continue
        }
        for (j = 0; j < remoteIdArr.length; j++) {
          if (arrTmp[i] == remoteIdArr[j]) {
            break
          }
        }
        if (j == remoteIdArr.length) {
          if (this.remoteId.string != "") {
            this.pppoeplusForm.remoteId = this.pppoeplusForm.remoteId.replace(
              arrTmp[i],
              this.remoteId.string
            )
          } else {
            this.pppoeplusForm.remoteId = this.pppoeplusForm.remoteId.replace(
              arrTmp[i] + " ",
              ""
            )
          }
          return
        }
      }

      /* remoteID加上自定义字符 */
      this.pppoeplusForm.remoteId += this.remoteId.string + " "
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
  watch: {
    "pppoeplusForm.circuitId": function (newValue, oldValue) {
      if (newValue == "") {
        /*初始化*/
        this.circuitId.clientMac = false
        this.circuitId.cvlan = false
        this.circuitId.gemport = false
        this.circuitId.hostname = false
        this.circuitId.oltInterfaceVlan = false
        this.circuitId.vlanNum = ""
        this.circuitId.ontId = false
        this.circuitId.ontIds = false
        this.circuitId.ontSn = false
        this.circuitId.port = false
        this.circuitId.switchMac = false
        this.circuitId.vlan = false
        this.circuitId.userDefined = false
        this.circuitId.string = ""
      }
    },
    "pppoeplusForm.remoteId": function (newValue, oldValue) {
      if (newValue == "") {
        /*初始化*/
        this.remoteId.clientMac = false
        this.remoteId.hostname = false
        this.remoteId.switchMac = false
        this.remoteId.userDefined = false
        this.remoteId.string = ""
      }
    },
  },
}
</script>